<template>
    <!-- Inizio Footer -->
<footer class="Footer">
	<div class="Container">
		<div class="BoxWide">
			<div class="FooterIndex">Portale Manutenzioni Conad</div>
			<div class="TopSwitch"><a @click="scrollToTop"><img src="/App_Skins/Sito/images/Spacer.png" alt="" /></a></div>
		</div>
	</div>
</footer>
<!-- Fine Footer -->
</template>

<script>
export default {
    name: "Footer",
	methods:{
		scrollToTop(){
			window.scrollTo(0,0);
		}
	}
}
</script>